import React from 'react';
import { styled, Divider, Button } from '@teko/ui';
import { t } from '../../i18n.es.js';
import { Tag } from '@teko/ds-foundation';
import { ListItem } from '../ListItem/ListItem.es.js';
import { OrderImage } from '../OrderImage/OrderImage.es.js';
import { ORDER_TAB_WAIT_PAYMENT } from '../../constant/order.es.js';
import { Text } from '../Text/Text.es.js';

const StyledListItem = styled(ListItem)`
  padding: 0px;
`;
const StyledOrderCode = styled(ListItem)`
  padding: 10px 16px;
`;
const StyledDiv = styled.div`
  padding: 16px;
  background: white;
`;
const OrderItemBottom = styled(ListItem)`
  padding: 16px 0 0 0;
`;
const StyledText = styled(Text)`
  line-height: 24px;
  margin-top: 8px;
  margin-left: 2px;
`;
const StyledTitle = styled(Text)`
  margin-left: 2px;
`;
const Wrapper = styled.div`
  margin-top: 8px;
`;
const OrderStatus = styled.div((props) => `
  font-size: 10px;
  color: #f8f9fa;
  width: max-content;
  height: 18px;
  border-radius: 4px;
  padding: 0 6px;
  background: ${props.bgc};
  text-transform: uppercase;
  font-weight: 500;
  display: flex;
  align-items: center;
`);
const StyledSeller = styled(Text)`
  display: inline;
`;
const OrderItem = ({
  order,
  showSeller = true,
  customPaymentText = ""
}) => {
  return /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement(StyledOrderCode, {
    title: "",
    left: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Text, {
      fontSize: 14,
      fontWeight: "500"
    }, t("M\xE3 \u0111\u01A1n"), " ", order.code)),
    right: /* @__PURE__ */ React.createElement(OrderStatus, {
      bgc: order.statusColor || "#F78212"
    }, order.status)
  }), /* @__PURE__ */ React.createElement(Divider, null), /* @__PURE__ */ React.createElement(StyledDiv, null, /* @__PURE__ */ React.createElement("div", {
    onClick: order.onClick
  }, /* @__PURE__ */ React.createElement(StyledListItem, {
    left: /* @__PURE__ */ React.createElement(OrderImage, {
      images: order.images
    }),
    title: /* @__PURE__ */ React.createElement(StyledTitle, {
      fontSize: 14,
      fontWeight: "400",
      maxLines: 2
    }, order.clearanceTypeTag && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Tag, {
      type: "secondary",
      variant: "branding",
      content: order.clearanceTypeTag
    }), "\xA0"), order.title),
    subTitle: /* @__PURE__ */ React.createElement(StyledText, {
      fontSize: 16,
      fontWeight: "500"
    }, order.grandTotal)
  })), /* @__PURE__ */ React.createElement(OrderItemBottom, {
    title: "",
    left: /* @__PURE__ */ React.createElement("div", null, order.seller && showSeller && /* @__PURE__ */ React.createElement(Text, {
      fontSize: 12,
      color: "#848788",
      fontWeight: "400"
    }, t("Cung c\u1EA5p b\u1EDFi"), " ", /* @__PURE__ */ React.createElement(StyledSeller, {
      fontSize: 12,
      color: "#047fff"
    }, order.seller)), /* @__PURE__ */ React.createElement(Text, {
      fontSize: 12,
      color: "#848788"
    }, order.createdAt), order.currentTab === ORDER_TAB_WAIT_PAYMENT && /* @__PURE__ */ React.createElement(Text, {
      fontSize: 12,
      color: "#f78212"
    }, order.note)),
    right: order.currentTab === ORDER_TAB_WAIT_PAYMENT && order.state === "WAITING_FOR_PAYMENT_CONFIRMATION" ? order.disablePurchase ? !customPaymentText && /* @__PURE__ */ React.createElement(Button, {
      disabled: true
    }, t("Thanh to\xE1n ngay")) : /* @__PURE__ */ React.createElement(Button, {
      onClick: order.onRepayment,
      variant: "primary"
    }, customPaymentText || t("Thanh to\xE1n ngay")) : ""
  })));
};

export { OrderItem, OrderStatus };
